import { findLast, filter } from 'lodash-es';

export const getChapters = (toc) => {
  return filter(toc, { level: 2 });
}

export const getChapter = (chapters, { cfiWithoutAssertions }) => {
  return findLast(chapters, (chap) => {
    return (window.Jigsaw.CFIUtils.compareCFIs(chap.cfi, cfiWithoutAssertions) <= 0);
  });
};
